import * as actionTypes from '../actionTypes/careerFinancials';

export default {
  updateGeneratedData: (params) => ({
    type: actionTypes.UPDATE_CAREER_FINANCIALS_DATA,
    payload: params,
  }),
  resetGeneratedData: () => ({
    type: actionTypes.RESET_CAREER_FINANCIALS_DATA,
  }),
};
